import { getWordPressAPIEndpoint } from "../../env";

export const WordPressEndpoints = {
  getPostIndex: () => getWordPressAPIEndpoint('posts?_embed'),
  getMedia: (id: number) => getWordPressAPIEndpoint(`media/${id}`),
}